import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaTranslations } from '../interfaces/sia-translations';
import { SiaHttpService } from '../services/http.service';
@Injectable({
  providedIn: 'root',
})
export class SiaI18nApi {
  private api = inject(SiaHttpService);

  private readonly apiController: string = 'i18n';

  getTranslationsFromDB(language: string): Promise<SiaTranslations[]> {
    if (!language) {
      return Promise.resolve([]);
    }
    let params = new HttpParams();
    params = params.set('language', `${language}`);
    return this.api.get(`${this.apiController}/get-translations`, { params });
  }

  getItalianText(text: string, language: string): Promise<string | null> {
    if (!text || !language) {
      return Promise.resolve(null);
    }
    let params = new HttpParams();
    params = params.set('text', `${text}`);
    params = params.set('language', `${language}`);
    return this.api.get(`${this.apiController}/get-italian-text`, {
      params,
      responseType: 'text',
    });
  }

  getItalianTextSync(text: string, language: string): string | null {
    const apiUrl = this.api.getApiUrl();
    if (!apiUrl) return null;

    const xhr = new XMLHttpRequest();
    const url = `${apiUrl}/${this.apiController}/get-italian-text?text=${encodeURIComponent(
      text,
    )}&language=${encodeURIComponent(language)}`;

    xhr.open('GET', url, false);
    try {
      xhr.send(null);
      if (xhr.status === 200) {
        const response = xhr.responseText;
        if (!response) return null;
        try {
          return JSON.parse(response);
        } catch {
          return response;
        }
      }
    } catch (e) {
      console.error('Sync translation failed', e);
    }
    return null;
  }

  createRemoteTranslation(translation: SiaTranslations) {
    if (
      !translation ||
      !translation.italianText ||
      translation.italianText == ''
    ) {
      return Promise.resolve(false);
    }
    return this.api.post(
      `${this.apiController}/insert-text-to-translate`,
      translation,
    );
  }
}
